var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('HeroSection'),_c('TechMarquee'),_c('BusinessLinesSection'),_c('TechBaseSection'),_c('ScenesSection'),_c('WhySection'),_c('DemoBand'),_c('CtaBand',{attrs:{"eyebrow":"Let's Talk","title":"有一个现场想数字化？先聊可行性","desc":"告诉我们你的地块、产线或业务系统现状，皓辰会在一个工作日内给出初步判断与思路。","bg":_vm.img('gen/cta-bg.jpg')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }